import { render, staticRenderFns } from "./ImportSurrogates.vue?vue&type=template&id=549d17c8&scoped=true&"
import script from "./ImportSurrogates.vue?vue&type=script&lang=js&"
export * from "./ImportSurrogates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549d17c8",
  null
  
)

export default component.exports